import { gql } from '@apollo/client';

export default gql`
  query LessonsStats($courseId: String!, $groupId: String!) {
    lessonsStats(courseId: $courseId, groupId: $groupId)
      @rest(
        type: "LessonStats"
        path: "courses/{args.courseId}/groups/{args.groupId}/lessons/stats"
      ) {
      lessons {
        _id
        name
        studentsCount
        totalStudents
      }
      students {
        _id
        name
        email
        personalId
        totalAttendances
        attendanceData
      }
    }
  }
`;
